import getShopWhatsappTokenByCode from "../../api/getShopWhatsappTokenByCode";
import {ShopDetailsProps} from "../../components/whatsappIntegrationButton/WhatsappIntegrationButton";
import {ShopProps} from "../../types/ShopProps";

interface LaunchWhatsAppSignupProps {
    loadWaba: () => void;
    selectedDomain?: string;
    shouldDisplayPhoneDialog?: boolean;
    shopDetails?: ShopDetailsProps;
    shop: ShopProps;
    isLoading: boolean;
    setIsLoading: (newVal: boolean) => void;
    onFailMetaOnboarding?: () => void;
}

const handleCode = async (code: string, loadWaba: () => void, selectedDomain?: string, setIsLoading?: (newVal: boolean) => void) => {
    console.log("in handleCode 1");
    if(selectedDomain) {
        await getShopWhatsappTokenByCode(selectedDomain, code);
        console.log("in handleCode 2");
        loadWaba();
        console.log("in handleCode 3");
        setIsLoading?.(false);

    }
}

export const launchWhatsAppSignup = ({ loadWaba, selectedDomain, shouldDisplayPhoneDialog = false, shopDetails = {}, shop, isLoading, setIsLoading, onFailMetaOnboarding }: LaunchWhatsAppSignupProps) => {
    console.log("shopDetails: ", shopDetails);
    // @ts-ignore
    FB.login(function (response) {
        console.log("in fbLogin: ", response);
        if (response.authResponse) {
            console.log("in fbLogin 1");
            const code = response.authResponse.code;
            console.log("in fbLogin 2");
            selectedDomain && code && handleCode(code, loadWaba, selectedDomain, setIsLoading);
            console.log("in fbLogin 3");

            console.log("in fbLogin 4");
        } else {
            console.log("in fbLogin 5");
            setIsLoading(false);
            onFailMetaOnboarding && onFailMetaOnboarding();
            console.log('User cancelled login or did not fully authorize.');
        }
    }, {
        config_id: '28147710814872633', // configuration ID obtained in the previous step goes here
        auth_type: "rerequest",
        response_type: 'code',     // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
            sessionInfoVersion: 3,  //  Receive Session Logging Info
            ...(shouldDisplayPhoneDialog ? {} : { featureType: 'only_waba_sharing' }),
            setup: {
                solutionID: "3779920795656331", // This is the Partner Solution ID
                business: {
                    name: shop?.friendlyName,
                    email: shopDetails?.email,
                    website: shopDetails?.website,
                    address: {
                        streetAddress1: shopDetails?.address1,
                        streetAddress2: shopDetails?.address2,
                        city: shopDetails?.city,
                        state: shopDetails?.state,
                        zipPostal: shopDetails?.zip,
                        country: shopDetails?.country,
                    },
                    phone: {
                        code: shopDetails?.phoneCode,
                        number: shopDetails?.phoneNumber,
                        displayName: shopDetails?.name,
                    },
                    timezone: shopDetails?.timezone,
                },
            }
        }
    });
}
